import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    template: require('./registrationDialogInvalidAddress.html')
})
export class RegistrationInvalidAddressDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<RegistrationInvalidAddressDialog>) public dialogRef: MatDialogRef<RegistrationInvalidAddressDialog>) {}

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

}
